import { Data } from '@generated/Foundation.GMI.model';
import { useSitecore } from '@sitecore-content-sdk/nextjs';
import { SiteSettings } from 'lib/page-props-factory/plugins/site-settings';

export function useSiteSettings(): SiteSettings | null {
  const { page } = useSitecore();
  const sitecoreContext = page?.layout?.sitecore?.context;
  const settings =
    ((sitecoreContext as Record<string, unknown>)?.siteSettings as SiteSettings) || null;
  return settings;
}

export function useContentGridSettings(): Data.Settings.ContentGridSettings | null {
  const siteSettings = useSiteSettings();
  const contentGridSettings =
    (siteSettings?.contentGridSettings as Data.Settings.ContentGridSettings) || null;
  return contentGridSettings;
}

type CardDetailLevelField = { id: string; name: string };

/**
 * Returns the fieldsToShow array from the site-level defaultCardDetailLevel setting.
 * Normalises both the flat shape { fieldsToShow } produced by getSiteSettings() and
 * the nested JSS shape { fields: { fieldsToShow } } so that runtime shape differences
 * never silently skip the site-level fallback.
 */
export function useDefaultCardDetailLevel(): CardDetailLevelField[] | undefined {
  const contentGridSettings = useContentGridSettings();
  const raw = (contentGridSettings?.fields as Record<string, unknown>)?.defaultCardDetailLevel as
    | { fieldsToShow?: CardDetailLevelField[]; fields?: { fieldsToShow?: CardDetailLevelField[] } }
    | undefined;

  if (!raw) return undefined;

  const resolved = raw.fieldsToShow ?? raw.fields?.fieldsToShow;
  return resolved?.length ? resolved : undefined;
}
